import { defineNuxtPlugin } from '#app'
import config from 'devextreme/core/config'

export default defineNuxtPlugin((nuxtApp) => {
    const nuxtConfig = useRuntimeConfig();

    config({
        licenseKey: nuxtConfig.public.devExtremeLicenseKey
    });
})
